import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const weightGainLoss: AnswerPathTreeNode = { path: 'weightGainLoss', nodeId: NodeIds.insuredWeightGainLoss };
